
import { Route } from '@/app/router'

const Collections = () => import('./index.vue')

const CollectionsMeta = {
	sort: 12,
	displayInSidebar: true,
	displayName: 'collection',
	icon: 'fal dolly-flatbed-alt',
	activeIcon: 'fas dolly-flatbed-alt'
}

const CollectionsProps = ['page', 'perPage']

export default new Route('/collections', Collections)
	.as('Dashboard:Collections')
	.meta(CollectionsMeta)
	.props(CollectionsProps)
	.permissions(['VIEW_COLLECTION'])
